module.exports = __webpack_public_path__ + "media/HapticInterface_Asset.ec1bae27.mp4";